import { useSelector } from 'react-redux';
import type { DealershipPickerState, StateTree } from '../types';

export const useDealershipSelector = (): DealershipPickerState => {
    const state: DealershipPickerState = useSelector((state: StateTree) => state.dealershipPicker);
    return state;
};
